module.exports = __webpack_public_path__ + "img/providers.51d74e5.webp";